/**
 * @ngdoc directive
 * @module components.query
 * @name components.query:query
 * @scope
 * @restrict E
 * @description
 * A utility widget for calling apis. The data returned by the api is accessed with "$ctrl.results."
 * @param {string} service The name of resource defined at /angular/services/global.js.
 * @param {number=} take The number of items to process. Typically used for apis that support pagination.
 * @param {string=} method The type of request to make to the service. Defaults to 'GET' if empty.
 * @param {object=} params Additional parameters that will be passed to the api.
 * @example
    <example module="dataExample">
        <file name="index.html">
            <div ng-controller="exampleController">
                <query service="global.blogPosts" take="5">
                    <div ng-repeat="post in $ctrl.results.items">
                        <h3>{{post.name}}
                        <p>{{post.summary}}
                    </div>
                </query>
            </div>
        </file>
        <file name="script.js">
            (function() {
                angular.module('dataExample', ['components.query', 'services.global'])
                    .controller('exampleController', exampleController);

                exampleController.$inject = ['$scope'];
                function exampleController($scope) {
                }
            })();
        </file>
    </example>
 */
(function () {
    angular.module('components.query', [])
        .component('query', {
            bindings: {
                'service': '@',
                'take': '<?',
                'method': '@?',
                'params': '<?',
                'trigger': '<?',
                'required': '@?',
                'onChange': '&?'
            },
            transclude: true,
            template: '<div class="loading-indicator" ng-hide="!$ctrl.loading"><div class="lds-ripple"><div></div><div></div></div></div><div class="content"></div>',
            controller: queryController
        })

    queryController.$inject = ['$scope', '$injector', '$transclude', '$element', '$timeout'];
    function queryController($scope, $injector, $transclude, $element, $timeout) {
        var ctrl = this;

        ctrl.$onInit = function () {
            $transclude($scope, function (clone) {
                if (clone.length) {
                    $element.append(clone);
                }
            });
        }

        ctrl.$onChanges = function (changes) {
            if (changes.method && !changes.method.currentValue) {
                ctrl.method = 'get';
            }
            if (changes.params && !changes.params.currentValue) {
                ctrl.params = {};
            }

            if (ctrl.take !== undefined) {
                ctrl.params.pageSize = ctrl.take;
            }
            if (changes.service) {
                var servicePieces = ctrl.service.split('.');
                var serviceContainer = $injector.get(servicePieces[0]);
                ctrl.$resource = serviceContainer[servicePieces[1]];
            }
            console.log(ctrl.$$paramsValid())
            if (changes.params && ctrl.$$paramsValid()) {
                ctrl.loading = true;
                ctrl.results = ctrl.$resource[ctrl.method](ctrl.params);
                ctrl.results.$promise.then(function (data) {
                    $timeout(function () {
                        ctrl.loading = false;
                        if (ctrl.onChange) {
                            ctrl.onChange({
                                data: data
                            });
                        }
                    })
                })
            }
        }

        ctrl.$$paramsValid = function () {
            if (!ctrl.required)
                return true;
            if (!ctrl.params) {
                return false;
            }
            var requirements = ctrl.required.replace(' ', '').split(',');
            for (var i = 0; i < requirements.length; i++) {
                var target = ctrl.params[requirements[i]];
                if (target === undefined || target === null)
                    return false;
            }
            return true;
        }
    }
})();